import React from 'react';
import {observer} from 'mobx-react';
import store from '../s';

const ModalInfo: React.FC = observer(() => {
    return (
        <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="prod-processing-title"
        >
            <div className="order-processing-container">
                <div>
                    <div
                        id="prod-processing-title"
                        className="form-label"
                        style={{fontSize: 24}}
                    >
                        {store.ui.processing_title}
                    </div>
                    <div style={{fontSize: 42, paddingTop: 24}}>
                        <i
                            className="fas fa-circle-notch fa-spin fast-spin"
                            aria-hidden={true}
                        ></i>
                    </div>
                    <div
                        style={{paddingTop: 24, fontSize: 18}}
                        className="form-label"
                        role="status"
                        aria-live="polite"
                    >
                        Please wait
                    </div>
                    <div style={{paddingTop: 6}}>{store.ui.processing_text}</div>
                </div>
            </div>
            <div className="order-processing" />
        </div>
    );
});

export default ModalInfo;
